import { Module } from "vuex";
import * as firebase from "firebase/app";
import "firebase/firestore";
import { serializer } from "@/api/shared/serializer";
import { EventLocations } from "@/enums/EventLocations";

const careLevelsModule: Module<any, any> = {
  namespaced: false,
  state: {
    careLevels: [],
  },
  mutations: {
    setCareLevels(state, data) {
      state.careLevels = data;
    }
  },
  actions: {
    async getCareLevels({ commit }) {

    const wingsSnap = await firebase
      .firestore()
      .collection("eventLocations")
      .where("facilityId", "==", this.state.authModule.currentFacility)
      .where("type", "==", EventLocations.Wing).get()

    const wings = serializer.querySnapshotToDocuments(wingsSnap)

     return await firebase
        .firestore()
        .collection("careLevels")
        .where("facilityId", "==", this.state.authModule.currentFacility)
        .get()
        .then((querySnapshot) => {
          const data = serializer.querySnapshotToDocuments(querySnapshot)
           .map((x: any) => {
                const c = x
                c.wingsNames = wings?.filter(w => c.wingsIds?.includes(w.id)).map((y: any) => y.name) || []
                return c
            });

          commit("setCareLevels", data)
          return data
        })
    },

    async addCareLevel({ dispatch }, form) {

      form.facilityId = this.state.authModule.currentFacility

      await firebase
        .firestore()
        .collection("careLevels")
        .add(form)
        .then(() => {
          dispatch("getCareLevels");
        });
    },
    async updateCareLevel({ dispatch }, form) {

      await firebase
        .firestore()
        .collection("careLevels")
        .doc(form.id)
        .update({
          name: form.name,
          wingsIds: form.wingsIds,
        })
        .then(() => {
          dispatch("getCareLevels");
        })
    },
    async deleteCareLevel({ dispatch }, careLevel) {
      await firebase
        .firestore()
        .collection("careLevels")
        .doc(careLevel.id)
        .delete()
        .then(async () => {
          dispatch("getCareLevels");
        });
    }
  }
};

export default careLevelsModule;